import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Target, TrendingUp, Cpu, Eye, Lightbulb } from 'lucide-react';
export function UseCases() {
  const cases = [{
    icon: <Globe className="w-6 h-6" data-id="element-185" />,
    title: 'Market Entry Strategy'
  }, {
    icon: <Target className="w-6 h-6" data-id="element-186" />,
    title: 'M&A Target Screening'
  }, {
    icon: <TrendingUp className="w-6 h-6" data-id="element-187" />,
    title: 'Growth Strategy & Pricing'
  }, {
    icon: <Cpu className="w-6 h-6" data-id="element-188" />,
    title: 'AI Opportunity Mapping'
  }, {
    icon: <Eye className="w-6 h-6" data-id="element-189" />,
    title: 'Competitive Intelligence'
  }, {
    icon: <Lightbulb className="w-6 h-6" data-id="element-190" />,
    title: 'New Product Validation'
  }];
  return <section id="use-cases" className="py-24 md:py-32 bg-secondary border-t border-border" data-id="element-191">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-192">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-8" data-id="element-193">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-194">
            <h2 className="text-xs text-accent tracking-[0.2em] uppercase mb-4" data-id="element-195">
              Applications
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif text-text-light" data-id="element-196">
              Perfect For
            </h3>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-197">
          {cases.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="group bg-primary border border-border p-8 hover:border-accent/50 transition-all duration-300 hover:-translate-y-1" data-id="element-198">
              <div className="text-text-muted group-hover:text-accent transition-colors duration-300 mb-6" data-id="element-199">
                {item.icon}
              </div>
              <h4 className="text-xl font-serif text-text-light" data-id="element-200">
                {item.title}
              </h4>
            </motion.div>)}
        </div>
      </div>
    </section>;
}